var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5 21",
    style: {
      enableBackground: "new 0 0 5 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A5A5A5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "dot-3",
    className: "st0",
    d: "M2.5,0C3.9,0,5,1.1,5,2.5S3.9,5,2.5,5S0,3.9,0,2.5S1.1,0,2.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dot-4",
    className: "st0",
    d: "M2.5,8C3.9,8,5,9.1,5,10.5S3.9,13,2.5,13S0,11.9,0,10.5S1.1,8,2.5,8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dot-5",
    className: "st0",
    d: "M2.5,16C3.9,16,5,17.1,5,18.5S3.9,21,2.5,21S0,19.9,0,18.5S1.1,16,2.5,16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.70676e31e579d062d1da0bd8f13572c2.svg";
export { ForwardRef as ReactComponent };